import React from "react";
import "./VirasatV2DefaultHomePage.scss"
import logo from "../../assets/logo.png"
import { useHistory } from "react-router";
import { sortByOrderAscending } from "../../helper/helper";
const VirasatV2DefaultHeroPage = ({ components, heroBackground }) => {

    const history = useHistory()
    const getComponents = (component) => {
        switch (component.ID) {
            case "VirasatDefaultHeroPage-subheadertop":
                return <div className="VirasatV2DefaultHeroPage-happyhr">{component?.Props?.text}</div>
            case "VirasatDefaultHeroPage-header":
                return <div className="VirasatV2DefaultHeroPage-hero-header-cont">
                    <div className="VirasatV2DefaultHeroPage-hero-header">{component?.Props?.header}</div>
                    <div className="VirasatV2DefaultHeroPage-hero-subheader">{component?.Props?.subheader}</div>
                </div>
            case "VirasatDefaultHeroPage-subheaderlink":
                return <div className="VirasatV2DefaultHeroPage-contct"

                    onClick={() => {
                        history.push(component?.Props?.href)
                    }}>{component?.Props?.text}</div>
            default:
                return <div />
        }

    }
    return (
        <div className="VirasatV2DefaultHeroPage" style={{
            backgroundImage: `linear-gradient(0deg, rgba(22, 65, 106, 0.4), rgba(22, 65, 106, 0.4)),
linear-gradient(0deg, rgba(22, 65, 106, 0.2), rgba(22, 65, 106, 0.2)),
linear-gradient(0deg, rgba(22, 65, 106, 0.2), rgba(22, 65, 106, 0.2)), url(${heroBackground})`
        }}>
            <div className="VirasatV2DefaultHeroPage-container">
                <div className="VirasatV2DefaultHeroPage-container-wrapper">
                    <div className="VirasatV2DefaultHeroPage-logo">
                        <img alt="" className="VirasatV2DefaultHeroPage-logo-img" src={logo} />
                    </div>
                    {sortByOrderAscending(components).map((component, key) => {
                        return (<div key={key}>
                            {getComponents(component)}
                        </div>)
                    })}
                </div>

            </div>
        </div>
    )
}
export default VirasatV2DefaultHeroPage